import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faBullseye } from '@fortawesome/free-solid-svg-icons';

class Nav extends Component {
  render() {
    const { user } = this.props;
    const isVerified = user && user.me && user.me.flags && user.me.flags.verified;

    let countryHandle;
    if (user && user.countryHandle) {
      countryHandle = user.countryHandle;
    }

    const PortNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/dashboard.svg'})`,
    };
    const DepNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/deposit.svg'})`,
    };
    const TraNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/trade.svg'})`,
    };
    const DirNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/direct.svg'})`,
    };
    const HisNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/history.svg'})`,
    };
    const AudNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/audit.svg'})`,
    };
    const RefNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/menu/referral.svg'})`,
    };
    const StandardNavIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/assets/standard-token.svg'})`,
      marginBottom: '6px',
    };
    const EurTradeIcon = {
      backgroundImage: `url(${process.env.REACT_APP_CDN + '/assets/icons/fiat/euro.svg'})`,
      marginBottom: '6px',
      backgroundSize: 'cover',
    };

    return (
      <div className={this.props.navOpen ? 'nav-open' : ''}>
        <div className="nav-back" onClick={() => this.props.toggleNav()} />
        <div className='nav-menu'>
          <Link to="/" className="nav-logo" onClick={() => this.props.toggleNav()} >
            <img alt="Vaultoro logo" src={ process.env.REACT_APP_CDN + '/assets/images/logo.svg'} />
            <span>Vaultoro</span>
          </Link>
          <ul onClick={() => this.props.toggleNav()} >
            <li>
              <NavLink exact to="/" activeClassName="active-nav">
                <div style={PortNavIcon} className="nav-icon ni-por" />
                <span>Portfolio</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/wallets" activeClassName="active-nav">
                <div style={DepNavIcon} className="nav-icon ni-dep" />
                <span>Wallets</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/direct" activeClassName="active-nav">
                <div style={DirNavIcon} className="nav-icon ni-tra" />
                <span>Vaultoro Direct</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/history" activeClassName="active-nav">
                <div style={HisNavIcon} className="nav-icon ni-his" />
                <span>History</span>
              </NavLink>
            </li>
            {/* <li>
              <Link to={{ pathname: "https://vaultoro.com/audit" }} target="_blank">
                <div style={AudNavIcon} className="nav-icon ni-aud" />
                <span>Audit</span>
              </Link>
            </li> */}
            <li>
              <NavLink exact to="/referral" activeClassName="active-nav">
                <div style={RefNavIcon} className="nav-icon ni-ref" />
                <span>Referral</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/automation" activeClassName="active-nav">
                <div className="nav-icon ni-ref">
                  <FontAwesomeIcon
                    style={{color: '#fff'}}
                    size="2x"
                    fixedWidth
                    icon={faBullseye}
                  />
                </div>
                <span>Automation</span>
              </NavLink>
            </li>
            <li>
              <NavLink exact to="/fiat-trade" activeClassName="active-nav">
                <div style={EurTradeIcon} className="nav-icon ni-fiat" />
                <span>
                  Buy with
                  {countryHandle === 'GB' ? (
                    ' GBP'
                  ) : (
                    ' Euro'
                  )}
                </span>
              </NavLink>
            </li>
            { !isVerified && (
              <li>
                <NavLink exact to="/kyc" activeClassName="active-nav">
                  <div className="nav-icon ni-ref">
                    <FontAwesomeIcon
                      style={{color: '#fff'}}
                      size="lg"
                      fixedWidth
                      icon={faIdCard}
                    />
                  </div>
                  <span>Identity</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Nav);
